import { useFormik } from 'formik'
import React from 'react'
import InputText from '../../../components/InputText/InputText'
import PropTypes from 'prop-types'
import {
    initialValues,
    validationSchema,
} from '../../../forms/ForgotPasswordForm'
import Button from '../../../components/Button/Button'

const ForgotPasswordForm = ({ onSubmit, formIsLoading, formError }) => {
    const { errors, touched, handleSubmit, getFieldProps, isValid } = useFormik(
        {
            initialValues,
            validationSchema,
            onSubmit: formValues => {
                return onSubmit(formValues)
            },
        },
    )

    return (
        <form
            onSubmit={handleSubmit}
            className="flex flex-col items-center justify-start w-full"
        >
            <p className="font-medium text-sm text-white text-center">
                Enter your email below to receive <br /> password reset
                instructions
            </p>

            <InputText
                {...getFieldProps('email')}
                error={touched['email'] && errors['email']}
                label="Email"
                variant="black"
                additionalClass="mt-6"
            />

            <Button
                text="Send"
                type="submit"
                variant="secondary"
                disabled={!isValid || formIsLoading}
                className="w-full disabled:bg-yellow disabled:text-black disabled:border-yellow mt-1"
            />
            {formError && (
                <p className="transition-all delay-200 pt-4 text-error font-medium text-sm">
                    {formError}
                </p>
            )}
        </form>
    )
}

ForgotPasswordForm.propTypes = {
    onSubmit: PropTypes.func.isRequired,
    formIsLoading: PropTypes.bool,
    formError: PropTypes.string,
}

export default ForgotPasswordForm
